import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as ZignetLogo } from '../../assets/images/logos/zignet.svg';
import { useAuth } from '../../hooks/auth';
import { AsideButton } from './components/AsideButton';
import SidebarData, { ISibebar } from './SidebarData';
import { Container } from './styles';

export const AsideMenu = () => {
  const { user } = useAuth();

  const { pathname } = useLocation();

  return (
    <Container>
      <div className="logoContainer">
        <Link to="/admin/dashboard">
          <ZignetLogo />
        </Link>
      </div>

      <ul>
        {SidebarData.filter(
          (data: ISibebar) =>
            user.profile === 'admin' || data.path !== 'pessoas'
        ).map((data: ISibebar) =>
          data.path ? (
            <Link to={data.path} key={data.id.toString()}>
              <AsideButton
                title={data.title}
                icon={data.icon}
                submenu={data.submenu}
                active={pathname.slice(7) === data.path ? 'active' : ''}
              />
            </Link>
          ) : (
            <AsideButton
              key={data.id.toString()}
              title={data.title}
              icon={data.icon}
              submenu={data.submenu}
            />
          )
        )}
      </ul>
    </Container>
  );
};
